import { statsBand } from "@/mocks/lustCaution";

export default function Hero() {
  const jump = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative w-full min-h-[640px] lg:min-h-[90vh] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20abstract%20background%20evoking%201940s%20Shanghai%2C%20deep%20crimson%20and%20warm%20gold%20tones%2C%20soft%20velvet%20and%20silk%20textures%2C%20tea%20house%20and%20mahjong%20table%20atmosphere%2C%20moody%20chiaroscuro%20lighting%2C%20painterly%20vintage%20film%20poster%20aesthetic%2C%20rich%20warm%20color%20palette%2C%20no%20text%2C%20no%20people&width=1920&height=1200&seq=lustcaution-hero-01&orientation=landscape"
          alt="1940 年代上海氛围的暖色电影感背景图"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 py-24">
        <div className="max-w-4xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm font-label tracking-wide backdrop-blur">
            <i className="ri-bookmark-3-line" aria-hidden="true"></i>
            版本差异 · 剧情解析 · 未删减片段
          </span>

          <h1 className="mt-6 font-heading text-background-50 font-semibold leading-tight text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
            色戒未删减版，到底和公映版差在哪？
          </h1>

          <p className="mt-6 text-background-100/90 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            从被删去的片段、被处理的镜头，到完整剧情里那些容易被忽略的转折，这里把它们一次讲清楚。
            看完这一页，你会明白删减真正影响的是什么——故事没变，人物的心却变得难懂。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => jump("compare")}
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 font-label text-sm md:text-base hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              先看版本差异对比
            </button>
            <button
              type="button"
              onClick={() => jump("plot")}
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 font-label text-sm md:text-base hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              直接读完整剧情
            </button>
          </div>
        </div>

        <div className="max-w-5xl mx-auto mt-14 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {statsBand.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur px-4 py-4 md:py-5 text-center"
            >
              <p className="font-heading text-background-50 text-2xl md:text-3xl font-semibold">
                {stat.value}
                <span className="text-sm md:text-base font-normal ml-1 text-accent-300">{stat.unit}</span>
              </p>
              <p className="mt-2 text-background-100/80 text-xs md:text-sm leading-snug">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}